import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2, ShieldQuestion } from "lucide-react";

export default function ConfirmDialog({
  open, onOpenChange, onConfirm, loading,
  title = "Emin misiniz?",
  description = "Bu değişikliği kaydetmek istediğinize emin misiniz?",
  confirmText = "Evet, kaydet",
  cancelText = "Hayır, düzenlemeye dön",
  tone = "green",
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="confirm-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading">
            <ShieldQuestion className="h-5 w-5 text-brand-orange" /> {title}
          </DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <div className="flex gap-2">
          <Button variant="outline" className="flex-1" data-testid="confirm-cancel" onClick={() => onOpenChange(false)}>
            {cancelText}
          </Button>
          <Button data-testid="confirm-ok" onClick={onConfirm} disabled={loading}
            className={`flex-1 text-white ${tone === "red" ? "bg-red-600 hover:bg-red-700" : "bg-brand-green hover:bg-brand-green-600"}`}>
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} {confirmText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
